import React from 'react';

/**
 * Security settings tab component
 * Displays authentication status and data security information
 */
const SecurityTab = () => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Authentication</h3>
        <div className="p-4 border border-gray-200 rounded-lg">
          <p className="text-sm text-gray-600 mb-4">
            This application uses JWT Authentication. Your session is automatically managed and persisted across browser sessions.
          </p>
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-green-500 rounded-full"></div>
            <span className="text-sm text-green-600">Authenticated and Connected</span>
          </div>
        </div>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Data Security</h3>
        <div className="space-y-4">
          <div className="p-4 border border-gray-200 rounded-lg">
            <h4 className="font-medium text-gray-900 mb-2">Data Encryption</h4>
            <p className="text-sm text-gray-600">
              All data is encrypted in transit and at rest using industry-standard encryption protocols.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityTab;